import { sendToFlutter } from './flutter-bridge'

const ACCESS_TOKEN_KEYS = ['accessToken', 'access_token', 'aura_access_token']
const REFRESH_TOKEN_KEYS = ['refreshToken']
const USER_INFO_KEYS = ['userCode', 'userName']

/** 가입 완료(/join/complete)에서 홈으로 나온 뒤 뒤로가기로 /join/* 로 못 가게 할 때 sessionStorage 키 */
export const JOIN_ROUTES_BACK_BLOCK_KEY = 'aura_block_join_routes'

function getSafeStorage(storageKey) {
  try {
    if (typeof window === 'undefined') return null
    const storage = window[storageKey]
    return storage || null
  } catch (_e) {
    return null
  }
}

function getStorages() {
  return {
    local: getSafeStorage('localStorage'),
    session: getSafeStorage('sessionStorage')
  }
}

export function activateJoinRoutesBackBlock() {
  const { session } = getStorages()
  if (!session) return
  session.setItem(JOIN_ROUTES_BACK_BLOCK_KEY, '1')
}

export function clearJoinRoutesBackBlock() {
  const { session } = getStorages()
  if (!session) return
  session.removeItem(JOIN_ROUTES_BACK_BLOCK_KEY)
}

function hasStorage() {
  const { local, session } = getStorages()
  return Boolean(local && session)
}

function readFromStorages(keys) {
  const { local, session } = getStorages()
  if (!local || !session) return null
  for (const key of keys) {
    const localValue = local.getItem(key)
    if (localValue) return localValue
    const sessionValue = session.getItem(key)
    if (sessionValue) return sessionValue
  }
  return null
}

function removeKeysFromStorages(keys) {
  const { local, session } = getStorages()
  if (!local || !session) return
  for (const key of keys) {
    local.removeItem(key)
    session.removeItem(key)
  }
}

export function getAccessToken() {
  return readFromStorages(ACCESS_TOKEN_KEYS)
}

export function hasAccessToken() {
  return Boolean(getAccessToken())
}

export function getRefreshToken() {
  return readFromStorages(REFRESH_TOKEN_KEYS)
}

export function setAccessToken(token, preferSession = false) {
  const { local, session } = getStorages()
  if (!token || !local || !session) return
  const previous = getAccessToken()
  removeKeysFromStorages(ACCESS_TOKEN_KEYS)
  if (preferSession) {
    session.setItem('accessToken', token)
  } else {
    local.setItem('accessToken', token)
  }

  // 로그인이 WebView 안에서 일어나므로 앱은 여기서 알려 줘야 안다.
  // 앱은 이 토큰으로 기기 토큰을 서버에 등록한다(푸시 규격 6.1).
  //
  // 토큰 재발급(인터셉터)에서도 이 함수가 불린다. 값이 그대로면 보내지 않는다 -
  // 같은 등록을 반복할 이유가 없다. 값이 바뀌었으면 보낸다. 앱이 들고 있는
  // 토큰도 같이 새것이 되어야 서버를 부를 수 있다.
  if (token !== previous) {
    sendToFlutter('LOGIN_SUCCESS', { accessToken: token })
  }
}

export function setRefreshToken(token, preferSession = false) {
  const { local, session } = getStorages()
  if (!token || !local || !session) return
  removeKeysFromStorages(REFRESH_TOKEN_KEYS)
  if (preferSession) {
    session.setItem('refreshToken', token)
    return
  }
  local.setItem('refreshToken', token)
}

export function setUserIdentity({ userCode, userName }, preferSession = false) {
  const { local, session } = getStorages()
  if (!local || !session) return
  removeKeysFromStorages(USER_INFO_KEYS)
  const targetStorage = preferSession ? session : local
  if (userCode) targetStorage.setItem('userCode', userCode)
  if (userName) targetStorage.setItem('userName', userName)
}

export function clearAuthStorage() {
  removeKeysFromStorages([...ACCESS_TOKEN_KEYS, ...REFRESH_TOKEN_KEYS, ...USER_INFO_KEYS])
  clearJoinRoutesBackBlock()

  // 앱이 서버의 기기 행을 비활성으로 바꾼다. 지우지 않는 이유는 같은 기기에
  // 다른 회원이 로그인할 수 있기 때문이다 - 남의 알림이 가면 안 된다.
  sendToFlutter('LOGOUT')
}

